import { createSlice } from "@reduxjs/toolkit";

interface commentSeen {
  hasSeened: string;
}

const initialState: commentSeen = {
  hasSeened: "",
};

export const CommentSlice = createSlice({
  name: "comment",
  initialState,
  reducers: {
    seenNotification: (state: any, action: any) => {
      const { hasSeened } = action.payload;
      state.hasSeened = hasSeened;
    },
  },
});

// this is for dispatch
export const { seenNotification } = CommentSlice.actions;

// this is for configureStore
export default CommentSlice.reducer;
